const Shortlisted = {
  title: '',
  img: '',
  location: '',
  category: '',
  booked: true,
  id: '',
  photos: {},
  address: '',
  name: '',
  thumbnail: {},
  count: 0,
};

export default Shortlisted;
